import Splide from '@splidejs/splide';
import { isMobileScreen } from './utils';
import { BREAKPOINTS } from './constants';

const setTwoItemPerPage = (list) => {
  const articles = list.querySelectorAll('article');

  const liOpenTag = '<li class="splide__slide">';
  const liCloseTag = '</li>';

  const html = Array.from(articles).reduce((acc, article, index) => {
    if (index % 2 === 0) {
      return acc + liOpenTag + article.outerHTML;
    } else {
      return acc + article.outerHTML + liCloseTag;
    }
  }, '');

  list.innerHTML = html;
};

const setCardsHeight = (list) => {
  const cards = list.getElementsByTagName('article');

  let maxHeight = 0;
  Array.from(cards)?.forEach((el) => {
    const currentElementHeight = el?.getBoundingClientRect();
    maxHeight = maxHeight > currentElementHeight.height ? maxHeight : currentElementHeight.height;
  });

  Array.from(cards)?.forEach((el) => {
    el.style.height = `${maxHeight}px`;
  });
};

const onTestimonialsLoad = () => {
  const testimonials = document.getElementsByClassName('testimonials');

  if (!testimonials.length) return;

  Array.from(testimonials).forEach((item) => {

    const list = item.querySelector('ul');

    const doubleCards = list.getAttribute('data-double') === 'true' && !isMobileScreen(BREAKPOINTS.LG);
    setCardsHeight(list);
    if (doubleCards) setTwoItemPerPage(list);

    const splide = new Splide(item, {
      autoWidth: true,
      focus: 0,
      perPage: 1,
      omitEnd: true,
      drag: list?.children?.length > 1
    });
    splide.mount();
  });

};

export default onTestimonialsLoad;

